import { Component, OnInit } from '@angular/core';
import { NotificationDataSource } from '../../services/notification-data-source';
import { NotificationApiService } from '../../services/notification-api-service';
import { Subscription } from 'rxjs';
import moment from 'moment';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NewNotification } from '../new-notification/component';
import { PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'notification-dashboard',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class NotificationDashboard implements OnInit {
  private Subscriptions: Subscription[] = [];
  public DataSource = new NotificationDataSource(
    this.NotificationApi,
    'notifcation-admin'
  );
  public notifications;
  public loading: boolean;
  public displayedColumns = ['date', 'title', 'text', 'image', 'url'];
  public PageEvent: PageEvent;

  constructor(
    private NotificationApi: NotificationApiService,
    private dialog: MatDialog
  ) {}

  async ngOnInit() {
    this.DataSource.connect();

    this.Subscriptions.push(
      this.DataSource.loading.subscribe((_loading) => (this.loading = _loading))
    );

    this.Subscriptions.push(
      this.DataSource.connect().subscribe((_notifications) => {
        this.notifications = _notifications.notifications.map(
          (notification) => {
            return {
              ...notification,
              date: moment(notification.created).format('YYYY-MM-DD'),
            };
          }
        );
      })
    );

    this.Subscriptions.push(
      this.DataSource.PageEvent.subscribe(
        (_PageEvent) => (this.PageEvent = _PageEvent)
      )
    );
    this.DataSource.loadWithPageEvent(this.PageEvent);
  }

  public newNotification = () => {
    const config = new MatDialogConfig();
    config.data = { DataSource: this.DataSource };
    this.dialog
      .open(NewNotification, config)
      .afterClosed()
      .subscribe(() => this.DataSource.loadWithPageEvent(this.PageEvent));
    console.log('new notification');
  };

  goToLink(url: string) {
    window.open(url, '_blank');
  }
}
